import axios from "axios";

export default () => ({
  kpis: {
    total_clients: 0,
    mrr: "0,00",
    realized_revenue: "0,00",
    overdue_count: 0,
    new_signups: 0,
  },
  recentTenants: [],
  isMetricsLoading: true,

  /**
   * Fetch specific metrics for the admin dashboard screen.
   */
  async initDashboardMetrics() {
    try {
      const response = await axios.get("/api/admin/dashboard");

      this.kpis = response.data.kpis;
      this.recentTenants = response.data.recent_tenants;
    } catch (error) {
      console.error("Failed to load dashboard metrics:", error);
    } finally {
      this.isMetricsLoading = false;
    }
  },

  /**
   * Translate subscription status to Portuguese for UI rendering.
   * * @param {string} status
   * @returns {string}
   */
  translateStatus(status) {
    const statuses = {
      ACTIVE: "Ativo",
      TRIAL: "Período de Teste",
      OVERDUE: "Atrasado",
      SUSPENDED: "Suspenso",
      INACTIVE: "Inativo",
      CANCELLED: "Cancelado",
    };

    return statuses[status] || status;
  },
});
